// src/supabase/client.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://rybknkymtoxpuabvfjtu.supabase.co'; // tu URL real
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ5Ymtua3ltdG94cHVhYnZmanR1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIwMjU0NDAsImV4cCI6MjA2NzYwMTQ0MH0.37qeWJ9mPdCMAnnQKDwHdsasFqvwhs5jMGaed3XquTg'; // tu anon key real

export const supabase = createClient(supabaseUrl, supabaseKey);
